const UserIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.23416 17.7635L1.23414 17.7638H1.24183H1.28183C1.55552 17.7638 1.7973 17.5422 1.82148 17.2521L1.8215 17.2521L1.82161 17.2503C2.03738 13.9746 5.18194 11.3838 9.00183 11.3838C12.8018 11.3838 15.9467 13.9548 16.1821 17.2309L16.1822 17.2321C16.2062 17.5204 16.4484 17.7682 16.7695 17.7435L16.7701 17.7434C17.0582 17.7194 17.3058 17.4776 17.2816 17.1569C17.0173 13.294 13.3632 10.2837 9.00183 10.2837C4.64053 10.2837 0.986808 13.2938 0.722111 17.1762C0.697895 17.4718 0.919714 17.7393 1.23416 17.7635ZM4.34183 4.90375C4.34183 7.47898 6.4266 9.56375 9.00183 9.56375C11.5771 9.56375 13.6618 7.47898 13.6618 4.90375C13.6618 2.32852 11.5771 0.24375 9.00183 0.24375C6.4266 0.24375 4.34183 2.32852 4.34183 4.90375ZM5.46183 4.90375C5.46183 2.95898 7.05706 1.36375 9.00183 1.36375C10.9466 1.36375 12.5418 2.95898 12.5418 4.90375C12.5418 6.84852 10.9466 8.44375 9.00183 8.44375C7.05706 8.44375 5.46183 6.84852 5.46183 4.90375Z"
        fill="#999999"
        stroke="#999999"
        stroke-width="0.2"
      />
    </svg>
  );
};
const WebsiteIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0013 19.4596C5.05963 19.4596 1.04297 15.443 1.04297 10.5013C1.04297 5.55963 5.05963 1.54297 10.0013 1.54297C14.943 1.54297 18.9596 5.55963 18.9596 10.5013C18.9596 15.443 14.943 19.4596 10.0013 19.4596ZM10.0013 2.79297C5.7513 2.79297 2.29297 6.2513 2.29297 10.5013C2.29297 14.7513 5.7513 18.2096 10.0013 18.2096C14.2513 18.2096 17.7096 14.7513 17.7096 10.5013C17.7096 6.2513 14.2513 2.79297 10.0013 2.79297Z"
        fill="#C4C4C4"
      />
      <path
        d="M7.49922 18.625H6.66589C6.32422 18.625 6.04089 18.3417 6.04089 18C6.04089 17.6583 6.30755 17.3833 6.64922 17.375C5.34089 12.9083 5.34089 8.09167 6.64922 3.625C6.30755 3.61667 6.04089 3.34167 6.04089 3C6.04089 2.65833 6.32422 2.375 6.66589 2.375H7.49922C7.69922 2.375 7.89089 2.475 8.00755 2.63333C8.12422 2.8 8.15755 3.00833 8.09089 3.2C6.52422 7.90833 6.52422 13.0917 8.09089 17.8083C8.15755 18 8.12422 18.2083 8.00755 18.375C7.89089 18.525 7.69922 18.625 7.49922 18.625Z"
        fill="#C4C4C4"
      />
      <path
        d="M12.4981 18.6243C12.4314 18.6243 12.3647 18.6159 12.2981 18.5909C11.9731 18.4826 11.7897 18.1243 11.9064 17.7993C13.4731 13.0909 13.4731 7.90759 11.9064 3.19092C11.7981 2.86592 11.9731 2.50759 12.2981 2.39925C12.6314 2.29092 12.9814 2.46592 13.0897 2.79092C14.7481 7.75759 14.7481 13.2243 13.0897 18.1826C13.0064 18.4576 12.7564 18.6243 12.4981 18.6243Z"
        fill="#C4C4C4"
      />
      <path
        d="M10 14.834C7.675 14.834 5.35833 14.509 3.125 13.8506C3.11667 14.184 2.84167 14.459 2.5 14.459C2.15833 14.459 1.875 14.1756 1.875 13.834V13.0006C1.875 12.8006 1.975 12.609 2.13333 12.4923C2.3 12.3756 2.50833 12.3423 2.7 12.409C7.40833 13.9756 12.6 13.9756 17.3083 12.409C17.5 12.3423 17.7083 12.3756 17.875 12.4923C18.0417 12.609 18.1333 12.8006 18.1333 13.0006V13.834C18.1333 14.1756 17.85 14.459 17.5083 14.459C17.1667 14.459 16.8917 14.1923 16.8833 13.8506C14.6417 14.509 12.325 14.834 10 14.834Z"
        fill="#C4C4C4"
      />
      <path
        d="M17.4992 8.62448C17.4325 8.62448 17.3658 8.61615 17.2992 8.59115C12.5908 7.02448 7.39917 7.02448 2.69084 8.59115C2.3575 8.69948 2.0075 8.52448 1.89917 8.19948C1.79917 7.86615 1.97417 7.51615 2.29917 7.40781C7.26584 5.74948 12.7325 5.74948 17.6908 7.40781C18.0158 7.51615 18.1992 7.87448 18.0825 8.19948C18.0075 8.45781 17.7575 8.62448 17.4992 8.62448Z"
        fill="#C4C4C4"
      />
    </svg>
  );
};
const BranchIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3346 19.457H1.66797C1.3263 19.457 1.04297 19.1737 1.04297 18.832C1.04297 18.4904 1.3263 18.207 1.66797 18.207H18.3346C18.6763 18.207 18.9596 18.4904 18.9596 18.832C18.9596 19.1737 18.6763 19.457 18.3346 19.457Z"
        fill="#C4C4C4"
      />
      <path
        d="M17.5 19.4596H2.5C2.15833 19.4596 1.875 19.1763 1.875 18.8346V5.5013C1.875 2.98464 3.31667 1.54297 5.83333 1.54297H14.1667C16.6833 1.54297 18.125 2.98464 18.125 5.5013V18.8346C18.125 19.1763 17.8417 19.4596 17.5 19.4596ZM3.125 18.2096H16.875V5.5013C16.875 3.6513 16.0167 2.79297 14.1667 2.79297H5.83333C3.98333 2.79297 3.125 3.6513 3.125 5.5013V18.2096Z"
        fill="#C4C4C4"
      />
      <path
        d="M8.33203 14.875H5.83203C5.49036 14.875 5.20703 14.5917 5.20703 14.25C5.20703 13.9083 5.49036 13.625 5.83203 13.625H8.33203C8.6737 13.625 8.95703 13.9083 8.95703 14.25C8.95703 14.5917 8.6737 14.875 8.33203 14.875Z"
        fill="#C4C4C4"
      />
      <path
        d="M14.168 14.875H11.668C11.3263 14.875 11.043 14.5917 11.043 14.25C11.043 13.9083 11.3263 13.625 11.668 13.625H14.168C14.5096 13.625 14.793 13.9083 14.793 14.25C14.793 14.5917 14.5096 14.875 14.168 14.875Z"
        fill="#C4C4C4"
      />
      <path
        d="M8.33203 11.125H5.83203C5.49036 11.125 5.20703 10.8417 5.20703 10.5C5.20703 10.1583 5.49036 9.875 5.83203 9.875H8.33203C8.6737 9.875 8.95703 10.1583 8.95703 10.5C8.95703 10.8417 8.6737 11.125 8.33203 11.125Z"
        fill="#C4C4C4"
      />
      <path
        d="M14.168 11.125H11.668C11.3263 11.125 11.043 10.8417 11.043 10.5C11.043 10.1583 11.3263 9.875 11.668 9.875H14.168C14.5096 9.875 14.793 10.1583 14.793 10.5C14.793 10.8417 14.5096 11.125 14.168 11.125Z"
        fill="#C4C4C4"
      />
      <path
        d="M8.33203 7.375H5.83203C5.49036 7.375 5.20703 7.09167 5.20703 6.75C5.20703 6.40833 5.49036 6.125 5.83203 6.125H8.33203C8.6737 6.125 8.95703 6.40833 8.95703 6.75C8.95703 7.09167 8.6737 7.375 8.33203 7.375Z"
        fill="#C4C4C4"
      />
      <path
        d="M14.168 7.375H11.668C11.3263 7.375 11.043 7.09167 11.043 6.75C11.043 6.40833 11.3263 6.125 11.668 6.125H14.168C14.5096 6.125 14.793 6.40833 14.793 6.75C14.793 7.09167 14.5096 7.375 14.168 7.375Z"
        fill="#C4C4C4"
      />
    </svg>
  );
};

const PhoneIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5155 14.1898C11.4856 14.1745 11.4553 14.1592 11.4248 14.1438C11.2737 14.0673 11.1168 13.988 10.9685 13.8914M11.5155 14.1898L6.97348 10.2528C8.21674 11.7862 9.52631 12.9755 10.9685 13.8914M11.5155 14.1898C11.6813 14.2727 11.8346 14.3514 11.9714 14.4385L11.5155 14.1898ZM10.9685 13.8914L10.9412 13.9333C10.9413 13.9334 10.9414 13.9334 10.9415 13.9335M10.9685 13.8914L10.9417 13.9336C10.9416 13.9336 10.9415 13.9335 10.9415 13.9335M10.9415 13.9335C11.0922 14.0316 11.2518 14.1123 11.403 14.1887C11.4333 14.2041 11.4633 14.2192 11.4928 14.2343L11.4932 14.2345C11.659 14.3174 11.8102 14.3952 11.9446 14.4806L11.9444 14.4809L11.949 14.4832C11.9559 14.4866 11.962 14.4901 11.9694 14.4943L11.9698 14.4945C11.9768 14.4985 11.9849 14.5032 11.9944 14.5079M10.9415 13.9335L11.9944 14.5079M11.9944 14.5079C11.9943 14.5079 11.9942 14.5078 11.9941 14.5078L12.017 14.4633L11.9946 14.508C11.9945 14.508 11.9945 14.508 11.9944 14.5079ZM18.5773 15.23L18.5419 15.2654L18.5773 15.23ZM18.5773 15.23L18.542 15.2654C18.7843 15.5077 18.8991 15.7546 18.8972 15.9999C18.8952 16.2457 18.7761 16.5003 18.5288 16.7577L18.5283 16.7583C18.3552 16.9437 18.1737 17.1211 17.9791 17.3074L17.9788 17.3077C17.9629 17.3232 17.9468 17.3388 17.9308 17.3543C17.656 17.621 17.3701 17.8986 17.11 18.2098C16.6436 18.7123 16.0896 18.9471 15.3697 18.9471C15.301 18.9471 15.2279 18.9431 15.1574 18.9389C13.8082 18.8525 12.5515 18.3257 11.6035 17.8745M18.5773 15.23L11.6035 17.8745M11.6035 17.8745C9.0324 16.6303 6.77534 14.8652 4.90253 12.6245C3.35958 10.7672 2.32262 9.03971 1.63702 7.18942L1.63696 7.18926C1.21172 6.05392 1.0523 5.14574 1.11779 4.32251C1.16652 3.78297 1.37284 3.33401 1.76225 2.9446L3.30359 1.40326C3.53711 1.17791 3.79038 1.06533 4.03108 1.06533C4.26707 1.06533 4.51188 1.1774 4.74138 1.41093L4.74134 1.41097L4.74308 1.41258C4.98289 1.63449 5.21027 1.86569 5.45046 2.10992C5.48726 2.14735 5.52437 2.18508 5.56187 2.22313L11.6035 17.8745ZM4.03824 13.3266L4.03832 13.3267C6.01544 15.6901 8.39569 17.5512 11.1125 18.868L11.1129 18.8682C12.1459 19.3578 13.5331 19.9415 15.0805 20.0416L15.0815 20.0417L15.0934 20.0422C15.1843 20.0461 15.2729 20.05 15.3655 20.05C16.4105 20.05 17.2526 19.6884 17.9378 18.9448C17.9412 18.9414 17.9518 18.9309 17.9597 18.9178C18.181 18.6512 18.4307 18.409 18.6946 18.153C18.714 18.1342 18.7334 18.1154 18.7529 18.0965C18.9479 17.9098 19.1473 17.7145 19.3386 17.5149C19.7874 17.0472 20.0146 16.513 20.0135 15.9795C20.0125 15.4458 19.783 14.9187 19.3296 14.4653L16.8396 11.9753C16.8395 11.9752 16.8394 11.975 16.8392 11.9749C16.4087 11.5276 15.8907 11.2886 15.3448 11.2886C14.7988 11.2886 14.2769 11.5277 13.8341 11.9704L12.3774 13.4271C12.25 13.3553 12.1201 13.2903 11.9985 13.2295L11.9979 13.2292C11.8321 13.1463 11.6809 13.0686 11.5465 12.9831L11.5465 12.9831C10.2008 12.1286 8.97807 11.0136 7.80816 9.57915C7.22748 8.84413 6.83589 8.22675 6.56121 7.601C6.94201 7.25494 7.29903 6.89375 7.64331 6.54137L7.64347 6.54119C7.76746 6.41307 7.89564 6.28489 8.02417 6.15637C8.47898 5.70155 8.72675 5.17141 8.72675 4.62909C8.72675 4.08699 8.48331 3.55679 8.02411 3.10176C8.02407 3.10172 8.02404 3.10169 8.024 3.10166L6.78919 1.86684C6.64832 1.72598 6.51527 1.58901 6.37832 1.44803L6.367 1.43637C6.09357 1.15466 5.80702 0.863932 5.52434 0.602007C5.08956 0.175884 4.57614 -0.05 4.03108 -0.05C3.48987 -0.05 2.97237 0.176114 2.52124 0.606163L2.52123 0.606153L2.52038 0.606999L0.970445 2.15694C0.398545 2.72884 0.0742514 3.42365 0.0069486 4.22707L0.00693179 4.22728C-0.0725525 5.22711 0.111832 6.28722 0.585923 7.56396C1.31349 9.53877 2.4108 11.3712 4.03824 13.3266Z"
        fill="#999999"
        stroke="#999999"
        stroke-width="0.1"
      />
    </svg>
  );
};

const EmailIcon = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.10812 3.33305C0.947499 3.22606 0.815788 3.08106 0.72469 2.91092C0.633593 2.74078 0.58593 2.55077 0.585938 2.35778V2.3568C0.585938 1.66395 1.14765 1.10227 1.84054 1.10227H18.1594C18.8522 1.10227 19.4139 1.66395 19.4139 2.3568V2.35778C19.4139 2.74969 19.2181 3.11559 18.8918 3.33305C17.2992 4.39496 12.5006 7.59382 10.6963 8.79694C10.4901 8.93444 10.2478 9.00781 9.99995 9.00781C9.75212 9.00781 9.50984 8.93444 9.30365 8.79694C7.49928 7.59382 2.70066 4.39496 1.10812 3.33305Z"
      stroke="#999999"
      stroke-width="1.3"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M0.585938 2.35426V13.6511C0.585894 13.8159 0.618355 13.9791 0.681462 14.1314C0.744568 14.2837 0.837082 14.422 0.95371 14.5385C1.07019 14.6551 1.20853 14.7476 1.3608 14.8107C1.51307 14.8738 1.6763 14.9063 1.84113 14.9062H18.1587C18.3236 14.9063 18.4868 14.8738 18.6391 14.8107C18.7913 14.7476 18.9297 14.6551 19.0462 14.5385C19.1628 14.422 19.2553 14.2837 19.3184 14.1314C19.3815 13.9791 19.414 13.8159 19.4139 13.6511V2.35426"
      stroke="#999999"
      stroke-width="1.3"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const AddressIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99844 12.3089C8.22344 12.3089 6.77344 10.8672 6.77344 9.08385C6.77344 7.30052 8.22344 5.86719 9.99844 5.86719C11.7734 5.86719 13.2234 7.30885 13.2234 9.09219C13.2234 10.8755 11.7734 12.3089 9.99844 12.3089ZM9.99844 7.11719C8.9151 7.11719 8.02344 8.00052 8.02344 9.09219C8.02344 10.1839 8.90677 11.0672 9.99844 11.0672C11.0901 11.0672 11.9734 10.1839 11.9734 9.09219C11.9734 8.00052 11.0818 7.11719 9.99844 7.11719Z"
      fill="#C4C4C4"
    />
    <path
      d="M10.0014 19.468C8.76803 19.468 7.52637 19.0013 6.5597 18.0763C4.10137 15.7096 1.3847 11.9346 2.4097 7.44297C3.3347 3.36797 6.89303 1.54297 10.0014 1.54297C10.0014 1.54297 10.0014 1.54297 10.0097 1.54297C13.118 1.54297 16.6764 3.36797 17.6014 7.4513C18.618 11.943 15.9014 15.7096 13.443 18.0763C12.4764 19.0013 11.2347 19.468 10.0014 19.468ZM10.0014 2.79297C7.57637 2.79297 4.4597 4.08464 3.6347 7.71797C2.7347 11.643 5.20137 15.0263 7.4347 17.168C8.87637 18.5596 11.1347 18.5596 12.5764 17.168C14.8014 15.0263 17.268 11.643 16.3847 7.71797C15.5514 4.08464 12.4264 2.79297 10.0014 2.79297Z"
      fill="#C4C4C4"
    />
  </svg>
);

const TypeIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2495 19.4599H7.74948C3.63281 19.4599 1.88281 17.7016 1.88281 13.5932V9.85156C1.88281 9.5099 2.16615 9.22656 2.50781 9.22656C2.84948 9.22656 3.13281 9.5099 3.13281 9.85156V13.5932C3.13281 17.0016 4.34115 18.2099 7.74948 18.2099H12.2411C15.6495 18.2099 16.8578 17.0016 16.8578 13.5932V9.85156C16.8578 9.5099 17.1411 9.22656 17.4828 9.22656C17.8245 9.22656 18.1078 9.5099 18.1078 9.85156V13.5932C18.1161 17.7016 16.3578 19.4599 12.2495 19.4599Z"
      fill="#C4C4C4"
    />
    <path
      d="M10.0011 11.1263C9.08447 11.1263 8.25114 10.768 7.65947 10.1096C7.06781 9.4513 6.79281 8.59297 6.88447 7.6763L7.44281 2.10964C7.47614 1.79297 7.74281 1.54297 8.06781 1.54297H11.9595C12.2845 1.54297 12.5511 1.78464 12.5845 2.10964L13.1428 7.6763C13.2345 8.59297 12.9595 9.4513 12.3678 10.1096C11.7511 10.768 10.9178 11.1263 10.0011 11.1263ZM8.62614 2.79297L8.12614 7.8013C8.06781 8.35963 8.23447 8.88463 8.58447 9.26797C9.29281 10.0513 10.7095 10.0513 11.4178 9.26797C11.7678 8.8763 11.9345 8.3513 11.8761 7.8013L11.3761 2.79297H8.62614Z"
      fill="#C4C4C4"
    />
    <path
      d="M15.258 11.1263C13.5663 11.1263 12.058 9.75963 11.883 8.0763L11.2997 2.23464C11.283 2.05964 11.3413 1.88464 11.458 1.7513C11.5747 1.61797 11.7413 1.54297 11.9247 1.54297H14.4663C16.9163 1.54297 18.058 2.56797 18.3997 5.08463L18.633 7.4013C18.733 8.38463 18.433 9.31797 17.7913 10.0263C17.1497 10.7346 16.2497 11.1263 15.258 11.1263ZM12.6163 2.79297L13.133 7.9513C13.2413 8.99297 14.208 9.8763 15.258 9.8763C15.8913 9.8763 16.458 9.63463 16.8663 9.19297C17.2663 8.7513 17.4497 8.15963 17.3913 7.5263L17.158 5.23463C16.8997 3.3513 16.2913 2.79297 14.4663 2.79297H12.6163Z"
      fill="#C4C4C4"
    />
    <path
      d="M4.69855 11.1263C3.70689 11.1263 2.80689 10.7346 2.16522 10.0263C1.52355 9.31797 1.22355 8.38463 1.32355 7.4013L1.54855 5.10964C1.89855 2.56797 3.04022 1.54297 5.49022 1.54297H8.03189C8.20689 1.54297 8.37355 1.61797 8.49855 1.7513C8.62355 1.88464 8.67355 2.05964 8.65689 2.23464L8.07355 8.0763C7.89855 9.75963 6.39022 11.1263 4.69855 11.1263ZM5.49022 2.79297C3.66522 2.79297 3.05689 3.34297 2.79022 5.2513L2.56522 7.5263C2.49855 8.15963 2.69022 8.7513 3.09022 9.19297C3.49022 9.63463 4.05689 9.8763 4.69855 9.8763C5.74855 9.8763 6.72355 8.99297 6.82355 7.9513L7.34022 2.79297H5.49022Z"
      fill="#C4C4C4"
    />
    <path
      d="M12.0846 19.4596H7.91797C7.5763 19.4596 7.29297 19.1763 7.29297 18.8346V16.7513C7.29297 15.0013 8.2513 14.043 10.0013 14.043C11.7513 14.043 12.7096 15.0013 12.7096 16.7513V18.8346C12.7096 19.1763 12.4263 19.4596 12.0846 19.4596ZM8.54297 18.2096H11.4596V16.7513C11.4596 15.7013 11.0513 15.293 10.0013 15.293C8.9513 15.293 8.54297 15.7013 8.54297 16.7513V18.2096Z"
      fill="#C4C4C4"
    />
  </svg>
);

const NoteIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7412 3.60938H4.60937C4.46019 3.60938 4.31712 3.66864 4.21163 3.77413C4.10614 3.87962 4.04688 4.02269 4.04688 4.17188C4.04688 4.32106 4.10614 4.46413 4.21163 4.56962C4.31712 4.67511 4.46019 4.73437 4.60937 4.73437H12.7419C12.8911 4.73429 13.0341 4.67495 13.1395 4.5694C13.245 4.46385 13.3041 4.32075 13.3041 4.17156C13.304 4.02238 13.2446 3.87934 13.1391 3.77391C13.0335 3.66848 12.8904 3.60929 12.7412 3.60938ZM13.3037 7.34312C13.3037 7.19394 13.2445 7.05087 13.139 6.94538C13.0335 6.83989 12.8904 6.78062 12.7412 6.78062H4.60937C4.46019 6.78062 4.31712 6.83989 4.21163 6.94538C4.10614 7.05087 4.04688 7.19394 4.04688 7.34312C4.04688 7.49231 4.10614 7.63538 4.21163 7.74087C4.31712 7.84636 4.46019 7.90562 4.60937 7.90562H12.7419C12.891 7.90546 13.0339 7.84612 13.1392 7.74065C13.2446 7.63518 13.3037 7.4922 13.3037 7.34312ZM4.60937 9.9525C4.46019 9.9525 4.31712 10.0118 4.21163 10.1173C4.10614 10.2227 4.04688 10.3658 4.04688 10.515C4.04688 10.6642 4.10614 10.8073 4.21163 10.9127C4.31712 11.0182 4.46019 11.0775 4.60937 11.0775H8.70562C8.85481 11.0775 8.99788 11.0182 9.10337 10.9127C9.20886 10.8073 9.26813 10.6642 9.26813 10.515C9.26813 10.3658 9.20886 10.2227 9.10337 10.1173C8.99788 10.0118 8.85481 9.9525 8.70562 9.9525H4.60937Z"
      fill="#999999"
    />
    <path
      d="M6.06938 17.6875H2.58875C2.35811 17.6872 2.13702 17.5954 1.97393 17.4323C1.81085 17.2692 1.71908 17.0481 1.71875 16.8175V2.1825C1.71875 1.7025 2.10937 1.3125 2.58875 1.3125H14.7612C15.2406 1.3125 15.6312 1.70312 15.6312 2.1825V7.52312C15.6312 7.67231 15.6905 7.81538 15.796 7.92087C15.9015 8.02636 16.0446 8.08563 16.1937 8.08563C16.3429 8.08563 16.486 8.02636 16.5915 7.92087C16.697 7.81538 16.7563 7.67231 16.7563 7.52312V2.1825C16.7558 1.65365 16.5455 1.1466 16.1716 0.772591C15.7977 0.398581 15.2907 0.188162 14.7619 0.1875H2.58875C2.05985 0.188162 1.55279 0.398561 1.1788 0.772553C0.804811 1.14654 0.594412 1.6536 0.59375 2.1825V16.8175C0.594412 17.3464 0.804811 17.8535 1.1788 18.2274C1.55279 18.6014 2.05985 18.8118 2.58875 18.8125H6.06938C6.21856 18.8125 6.36163 18.7532 6.46712 18.6477C6.57261 18.5423 6.63188 18.3992 6.63188 18.25C6.63188 18.1008 6.57261 17.9577 6.46712 17.8523C6.36163 17.7468 6.21856 17.6875 6.06938 17.6875Z"
      fill="#999999"
    />
    <path
      d="M16.7879 10.0735C16.395 9.68126 15.8625 9.46094 15.3073 9.46094C14.7521 9.46094 14.2195 9.68126 13.8266 10.0735L8.65476 15.2454C8.49152 15.408 8.38315 15.6176 8.34476 15.8448L8.06226 17.5217C8.03292 17.6959 8.04567 17.8747 8.09945 18.0431C8.15323 18.2114 8.24648 18.3645 8.37143 18.4895C8.49637 18.6145 8.64939 18.7078 8.81772 18.7617C8.98606 18.8156 9.16483 18.8284 9.33913 18.7992L11.0148 18.516C11.2435 18.4779 11.4516 18.371 11.6154 18.2067L16.7873 13.0348C17.1795 12.6419 17.3998 12.1094 17.3999 11.5543C17.4 10.9991 17.1799 10.4666 16.7879 10.0735ZM10.8291 17.4067L9.17163 17.7085L9.44976 16.0404L13.1716 12.3185L14.5429 13.6898L10.8291 17.4067ZM15.9923 12.2392L15.3379 12.8942L13.9666 11.5229L14.6216 10.8679C14.8104 10.6792 15.0591 10.5848 15.3073 10.5848C15.499 10.5847 15.6864 10.6414 15.8459 10.7479C16.0053 10.8544 16.1296 11.0058 16.2029 11.1829C16.2763 11.3601 16.2954 11.555 16.2579 11.743C16.2204 11.931 16.1279 12.1037 15.9923 12.2392Z"
      fill="#999999"
    />
  </svg>
);

export const contactInsheet = [
  {
    label: "Name",
    value: "contactPerson",
    icon: <UserIcon />,
  },
  {
    label: "Email",
    value: "contactEmail",
    icon: <EmailIcon />,
  },
  {
    label: "Contact",
    value: "contactNumber",
    icon: <PhoneIcon />,
  },
  {
    label: "Location",
    value: "location",
    icon: <AddressIcon />,
  },
];
export const contactInsheetDetail = [
  {
    label: "Name",
    value: "contactName",
    icon: <UserIcon />,
  },
  {
    label: "Email",
    value: "contactEmail",
    icon: <EmailIcon />,
  },
  {
    label: "Contact",
    value: "contactNumber",
    icon: <PhoneIcon />,
  },
  {
    label: "Location",
    value: "location",
    icon: <AddressIcon />,
  },
];
export const corporateInsheetDetail = [
  {
    label: "Type",
    value: "type",
    icon: <TypeIcon />,
  },
  {
    label: "Website",
    value: "company_website",
    icon: <WebsiteIcon />,
  },
  {
    label: "Location",
    value: "location",
    icon: <AddressIcon />,
  },
  {
    label: "Branch",
    value: "branch",
    icon: <BranchIcon />,
  },
];
